import { render, staticRenderFns } from "./a2.vue?vue&type=template&id=9b0f39b8&scoped=true"
import script from "./a2.vue?vue&type=script&lang=js"
export * from "./a2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0f39b8",
  null
  
)

export default component.exports